import { Button, Checkbox, Col, Input, Popconfirm, Row, Select, message } from "antd";
import { ClearOutlined } from "@ant-design/icons";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
const { TextArea } = Input;

export default function ResetVerifications (props) {
  const [tabsNum, setTabsNum] = useState('5');

  const [sheetURL, setSheetURL] = useState('');
  const [sheetName, setSheetName] = useState('');

  const [fileType, setFiletype] = useState('Passport');
  const [country, setCountry] = useState('United States');

  const [files, setFiles] = useState('Nguyễn Văn A/T.pdf/S.pdf/L.pdf');

  const [messageApi, contextHolder] = message.useMessage();

  const [reset, setReset] = useState(true);
  const [upFile, setUpFile] = useState(true);

  const resetProfile = async () => {
    let body = {
      tabsNum,
      sheet: {
        sheetId: sheetURL.split('/d/')[1].split('/edit')[0], 
        sheetName: sheetName,
      },
      verifyInfo: {
        type: fileType,
        country: country
      },
      filesStr: files,
      reset,
      upFile
    };
    axios
      .post(`${API_HOST}/api/reset-verification`, body)
      .then((res) => messageApi.success("Đã đặt lệnh"))
      .catch((e) => {
        console.log("🚀 ~ active ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  useEffect( () => {
    let sheetName = localStorage.getItem('reset-verify-sheetName')
    if(sheetName) {
      setSheetName(sheetName)
    }
    let sheetURL = localStorage.getItem('reset-verify-sheetURL')
    if(sheetURL) {
      setSheetURL(sheetURL)
    }
    
    let tabsNum = localStorage.getItem('reset-verify-tabs')
    if(tabsNum) {
      setTabsNum(tabsNum)
    }
    let reset = localStorage.getItem('reset-verify-reset')
    if(reset) {
      setReset(reset === 'true')
    }
    let upFile = localStorage.getItem('reset-verify-upFile')
    if(upFile) {
      setUpFile(upFile === 'true')
    }

    const files = localStorage.getItem('verify-files');
    if(files) {
      setFiles(files);
    }
    const fileType = localStorage.getItem('verify-fileType');
    if(fileType) {
      setFiletype(fileType);
    }
    const country = localStorage.getItem('verify-country');
    if(country) {
      setCountry(country);
    }

  }, [])

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ minWidth: 500 }}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Reset Verifications TKCN"
        description={
          <>
              <b>Profiles GG sheet: </b>
              <Row>
                <Col span={4}>
                  <label>SL Chrome: </label>
                </Col>
                <Col span={20}>
                  <Input
                    value={tabsNum}
                    type="number"
                    style={{ width: 60 }}
                    placeholder="Số Lượng Chrome..."
                    onChange={(e) => {
                      setTabsNum(e.target.value);
                      localStorage.setItem('reset-verify-tabs', e.target.value);
                    }}
                  />
                </Col>
                <Col span={4}>
                  <label>URL: </label>
                </Col>
                <Col span={18}>
                  <Input
                    value={sheetURL}
                    style={{ width: 400 }}
                    placeholder="https://docs.google.com/spreadsheets/d/15CVrJD5DBJ5k..."
                    onChange={(e) => {
                      setSheetURL(e.target.value);
                      localStorage.setItem('reset-verify-sheetURL', e.target.value);
                    }}
                  />
                </Col>
                <Col span={4}>
                  <label>Trang: </label>
                </Col>
                <Col span={18}>
                    <Input
                      value={sheetName}
                      style={{ width: 200 }}
                      placeholder="Reset verification..."
                      onChange={(e) => {
                        setSheetName(e.target.value);
                        localStorage.setItem('reset-verify-sheetName', e.target.value);
                      }}
                    />
                </Col>
                <Col span={4}>
                    <label><b>Reset Verification</b></label>
                </Col>
                <Col span={18}>
                    <Checkbox checked={reset} onChange={e => {
                      setReset(e.target.checked);
                      localStorage.setItem('reset-verify-reset', e.target.checked+'');
                    }}>
                    </Checkbox>
                </Col>
                <Col span={4}>
                    <label><b>Up File</b></label>
                </Col>
                <Col span={18}>
                    <Checkbox checked={upFile} onChange={e => {
                      setUpFile(e.target.checked);
                      localStorage.setItem('reset-verify-upFile', e.target.checked+'');
                    }}>
                    </Checkbox>
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                <br />
                <form id="active-form">
                  <Row>
                    <Col span={12}>
                      <label>Chọn Loại File: </label>
                      <Select
                          style={{width: '200px'}}
                          value={fileType}
                          placeholder="Chọn Loại File ... "
                          onChange={(v) => {
                            setFiletype(v);
                            window.localStorage.setItem("verify-fileType", v);
                          }}
                          options={[
                            {
                              label: 'Passport',
                              value: 'Passport',
                            },
                            {
                              label: 'CCCD',
                              value: 'National Identity Card',
                            },
                            {
                              label: 'Driver License',
                              value: 'Driver License',
                            },
                          ]}
                        />
                    </Col>
                    <Col span={12}>
                      <label>Chọn Quốc Gia: </label>
                      <Select
                          style={{width: '200px'}}
                          value={country}
                          placeholder="Chọn Quốc Gia ... "
                          onChange={(v) => {
                            setCountry(v);
                            window.localStorage.setItem("verify-country", v);
                          }}
                          options={[
                            {
                              label: 'VN',
                              value: 'Vietnam',
                            },
                            {
                              label: 'US',
                              value: 'United States',
                            },

                          ]}
                        />
                    </Col>
                  </Row>
                  <button type="submit" style={{display:'none'}}></button>
                </form>
                </Col>

              </Row>
              <br />
              <label>
                <strong>Tên Người + Ảnh Upload: Theo Mẫu <i style={{color:'red'}}>(Mỗi Người 1 dòng)</i></strong>
                <br/>
                <div>...</div>
                <div>Tên-1 / Ảnh Trước / Ảnh Sau / Ảnh Lỗi</div>
                <div>Tên-2 / Ảnh Trước / Ảnh Sau / Ảnh Lỗi</div>
                <div>...</div>
                {/* <br />VD: <i style={{color:'red'}}>1.jpg,2.pdf/4T.pdf-4S.pdf/7.pdf</i> = <u>Ảnh 1</u> [1.jpg hoặc 2.pdf] + <u>Ảnh 2</u> [4T.pdf Trước và 4S.pdf Sau] + <u>Ảnh Lỗi</u> [7.pdf] */}
              </label>
              <TextArea 
                style={{width: 800}}
                rows={10}
                value={files}
                placeholder='Nguyễn Văn A/T.pdf/S.pdf/L.pdf'
                onChange={(e) => {
                      setFiles(e.target.value );
                      window.localStorage.setItem("verify-files", e.target.value);
                }} />
              <br />

          </>
        }
        onConfirm={() => resetProfile()}
      >
        <Button style={{backgroundColor:'green', color:'white'}}><ClearOutlined />Reset</Button>
      </Popconfirm>
    </>
  );
}